import * as React from 'react';
import { DetailsList, DetailsListLayoutMode, IColumn, MarqueeSelection, Stack, Selection, ShimmeredDetailsList, ActionButton, Separator, SelectionMode, ProgressIndicator, Link, Icon, IRenderFunction, IDetailsHeaderProps, DetailsHeader, IDetailsColumnStyles, useTheme, IDetailsHeaderStyles, ComboBox, IComboBoxOption, PrimaryButton, IComboBoxProps } from '@fluentui/react';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IEventItem } from '../../../../../Models/Event/IEventItem';
import { PageTitle } from '../../../../PageTitle';
import { EventPriceTypeEnum } from '../../../../../Models/Event/EventPriceTypeEnum';
import { IEventSreachFilter } from '../../../../../Models/Event/IEventSreachFilter';
import { IEventType } from '../../../../../Models/EventTypes/IEventType';
import { IAgeGoup } from '../../../../../Models/AgeGroups/IAgeGroup';
import { IUserListItem } from '../../../../../Models/Admin/IUserListItem';
import { EventTilesListView } from '../../../../Events/Events/EventTileList/EventTileListView';


interface IEventListViewProps {
    items: IEventItem[];
    statusMessage?: IStatusMessage;
    isLoading: boolean;
    addGroup: () => void;
    selectItem: (item: IEventItem) => void;
    deleteItem: (id: number, desc: string) => void;
    filter?: IEventSreachFilter;
    eventTypes: IEventType[];
    district: string[];
    ageGroups: IAgeGoup[];
    schoolYears: number[];
    propertyChanged: (key: string, value: any) => void;
    teachers: IUserListItem[];
}



export const EventListView: React.FunctionComponent<IEventListViewProps> = (props) => {
    const [selected, setSelected] = React.useState<IEventItem[]>([]);
    const [selectionState] = React.useState(new Selection({
        onSelectionChanged: () => {
            const selected = selectionState.getSelection() as IEventItem[];
            setSelected(selected);
        },
    }));

    const [eventTypeOptions, setEventTypeOptions] = React.useState<IComboBoxOption[]>([])
    const [ageGroupOptions, setAgeGroupOptions] = React.useState<IComboBoxOption[]>([])
    const [roomOptions, setRoomOptions] = React.useState<IComboBoxOption[]>([])
    const [schoolYearOptions, setSchoolYearOptions] = React.useState<IComboBoxOption[]>([])

    const [teachersOptions, setTeachersOptions] = React.useState<IComboBoxOption[]>([])


    const theme = useTheme();


    React.useEffect(() => {
        const options = props.schoolYears.map(x => {
            const o: IComboBoxOption = {
                key: x,
                text: x.toString()
            }
            return o;
        });
        options.push({ key: 0, text: "Nerozhoduje" })
        setSchoolYearOptions(options)
    }, [props.schoolYears])

    React.useEffect(() => {
        const options = props.teachers.map(x => {
            const o: IComboBoxOption = {
                key: x.id,
                text: x.firstName + " " + x.lastName
            }
            return o;
        });
        options.push({ key: 0, text: "Nerozhoduje" })
        setTeachersOptions(options)
    }, [props.teachers])


    React.useEffect(() => {
        const options = props.ageGroups.map(x => {
            const o: IComboBoxOption = {
                key: x.id,
                text: x.name
            }
            return o;
        });
        options.push({ key: 0, text: "Nerozhoduje" })
        setAgeGroupOptions(options)
    }, [props.ageGroups])

    React.useEffect(() => {
        const options = props.eventTypes.map(x => {
            const o: IComboBoxOption = {
                key: x.id,
                text: x.name
            }
            return o;
        });
        options.push({ key: 0, text: "Nerozhoduje" })
        setEventTypeOptions(options)
    }, [props.eventTypes]);

    React.useEffect(() => {
        const options = props.district.map(x => {
            const o: IComboBoxOption = {
                key: x,
                text: x
            }
            return o;
        });
        options.push({ key: "", text: "Nerozhoduje" })
        setRoomOptions(options)
    }, [props.district])


    const headerStyle: Partial<IDetailsColumnStyles> = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,
        },
    }

    React.useEffect(() => {
        if (selected.length > 0) {
            // props.selectItem(selected[0]);
        }
    }, [selected])

    const _columns: IColumn[] = [
        { key: 'name', name: 'Název', fieldName: 'name', minWidth: 100, maxWidth: 200, isResizable: true, styles: headerStyle },
        { key: 'schoolYear', isCollapsible: true, name: 'Školní rok', fieldName: 'schoolYear', minWidth: 60, maxWidth: 90, isResizable: true, styles: headerStyle },
        { key: 'ageGroupName', isCollapsible: true, name: 'Věková skupina', fieldName: 'ageGroupName', minWidth: 80, maxWidth: 150, isResizable: true, styles: headerStyle },
        { key: 'price', name: 'Cena', fieldName: 'price', minWidth: 60, maxWidth: 150, isResizable: true, styles: headerStyle },
        { key: 'isCamp', isCollapsible: true, name: 'Tábor', fieldName: 'isCamp', minWidth: 80, maxWidth: 150, isResizable: true, styles: headerStyle },
        { key: 'deleteButton', name: "delete", minWidth: 50, isIconOnly: true },
    ];

    const renderPrice = (item: IEventItem) => {
        return (<>
            {item && item.priceType === EventPriceTypeEnum.ByEvent ?
                <span>{item.price},- Kč</span>
                : null}
            {item && item.priceType === EventPriceTypeEnum.BySemester ?
                <div>
                     
                    {item.firstSemesterPrice == item.secondSemesterPrice ?
                        <span>Pololetí: {item.firstSemesterPrice},- Kč</span>
                        :
                        <Stack horizontalAlign="end" tokens={{ childrenGap:0 }}>
                            <span>První pololetí: {item.firstSemesterPrice},- Kč</span>
                            <span>Druhé pololetí: {item.secondSemesterPrice},- Kč</span>
                        </Stack>
                    }
                </div>
                : null}

        </>)
    }

    const renderItemColumn = (item: IEventItem, index?: number, column?: IColumn) => {
        if (index != undefined && column != undefined) {
            const fieldContent = item[column.fieldName as keyof IEventItem];
            switch (column.key) {

                case 'name':
                    return <span style={{
                        height: '100%', display: 'flex', fontSize: 14,
                        alignItems: 'center'
                    }}><Link onClick={() => props.selectItem(item)}>{fieldContent}</Link></span>
                case 'isCamp':
                    return item.isCamp ? <Stack horizontalAlign="start" styles={{ root: { paddingLeft: 15 } }}><Icon title="Tábor" styles={{ root: { fontSize: 16 } }} iconName="Street" /></Stack> : null;
                case 'price':
                    return  <Stack horizontalAlign="end" styles={{ root: { paddingLeft: 15 } }}>{renderPrice(item)}</Stack>;

                case 'deleteButton':
                    return <div><Link title={fieldContent as string} onClick={() => { props.deleteItem(item.id, item.name) }}><Icon styles={{ root: { fontSize: 16 } }} iconName="Delete" /></Link ></div>;
                default:
                    return <span style={{
                        height: '100%', display: 'flex', fontSize:14,
                        alignItems: 'center'
                    }}>{fieldContent}</span>;
            }
        }
        else {
            return (<div></div>)
        }
    }

    const headerRowStyle: Partial<IDetailsHeaderStyles> = {
        root: {
            borderColor: theme.palette.blue,
            borderBottomWidth: 2
        }
    }

    const onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (props) {
            props = { ...props, styles: headerRowStyle };
            return (
                <DetailsHeader
                    {...props}                    
                />
            );
        }
        return null;
    }


    const onEventTypeChanged: IComboBoxProps['onChange'] = (event, option) => {
        props.propertyChanged("eventTypeId", option!.key as number);
    }

    const onDistrictChanged: IComboBoxProps['onChange'] = (event, option) => {
        props.propertyChanged("district", option!.key as string);
    }

    const onSchoolYearChanged: IComboBoxProps['onChange'] = (event, option) => {
        props.propertyChanged("schoolYear", option!.key as number);
    }

    const onAgeGroupChanged: IComboBoxProps['onChange'] = (event, option) => {
        props.propertyChanged("ageGoroupId", option!.key as number);
    }

 
    const onTeacherChanged: IComboBoxProps['onChange'] = (event, option) => {
        props.propertyChanged("teacherId", option!.key as string);
    }


    return (
        <Stack styles={{ root: { paddingLeft: 20, paddingRight: 20 } }}>            
            <PageTitle title="Aktivity" />  

            <Stack wrap horizontal verticalAlign="end" tokens={{ childrenGap: 10 }} styles={{ root: { paddingTop: 20 } }}>
                <Stack grow>
                    <ComboBox onChange={onEventTypeChanged} selectedKey={props.filter?.eventTypeId} placeholder="Vyberte typ kurzu který vás zajímá" label="Typ kurzu" options={eventTypeOptions} />
                </Stack>
                <Stack grow>
                    <ComboBox onChange={onDistrictChanged} text={props.filter?.district} allowFreeform label="Místo konání" placeholder="Vyberte místo konání" options={roomOptions} />
                </Stack>
                <Stack grow>
                    <ComboBox onChange={onSchoolYearChanged} selectedKey={props.filter?.schoolYear} label="Školní rok" options={schoolYearOptions} />
                </Stack>
                <Stack grow>
                    <ComboBox onChange={onAgeGroupChanged} selectedKey={props.filter?.ageGoroupId} label="Věková skupina" placeholder="Vyberte věkovou skupinu" options={ageGroupOptions} />
                </Stack>
                <Stack grow>
                    <ComboBox onChange={onTeacherChanged} selectedKey={props.filter?.teacherId} label="Lektor" placeholder="Vyberte lektora" options={teachersOptions} />
                </Stack>
            </Stack>

            <ActionButton iconProps={{ iconName: "Add" }} onClick={props.addGroup} >Přidat událost</ActionButton>
            <Stack styles={{ root: { height: 10 } }}>
                {props.isLoading ? <ProgressIndicator /> : null}
            </Stack>
            <MarqueeSelection selection={selectionState}>
                <DetailsList
                    items={props.items}
                    columns={_columns}
                    setKey="set"
                    onRenderDetailsHeader={onRenderDetailsHeader}                    
                    selectionMode={SelectionMode.single}
                    layoutMode={DetailsListLayoutMode.justified}
                    onRenderItemColumn={renderItemColumn}
                    selection={selectionState}
                    selectionPreservedOnEmptyClick={false}
                    ariaLabelForSelectionColumn="Výběr události"
                    ariaLabelForSelectAllCheckbox="Výběr události"
                    checkButtonAriaLabel="Vyber řádek"
                    onItemInvoked={(item: IEventItem) => props.selectItem(item)}
                />
            </MarqueeSelection>
        </Stack>
    )
}